import { createClient } from '@supabase/supabase-js';

import { env } from '../env';

/**
 * The admin's Supabase client.
 *
 * Sessions live in `localStorage`, supabase-js's default, and that is a real tradeoff
 * rather than an oversight: a token there is readable by any script that achieves
 * execution in the page. The mitigation is structural — no user-supplied HTML, no
 * third-party script tags, bundle built from this repository. A future feature that
 * pastes untrusted HTML into a DataGrid cell has to argue with this paragraph first.
 * Spec 008 section 4.3.
 */
export const supabase = createClient(
  env.VITE_SUPABASE_URL,
  env.VITE_SUPABASE_ANON_KEY,
);

/**
 * The token getter for the generated SDK.
 *
 * `getSession()` rather than a value captured at sign-in: it returns the stored
 * session and refreshes it when it has expired, so a request made after the tab sat
 * open all afternoon carries a live token rather than a stale one.
 */
export async function accessToken(): Promise<string | null> {
  const { data } = await supabase.auth.getSession();
  return data.session?.access_token ?? null;
}
